import { useState } from 'react'
import { VStack } from '@chakra-ui/react';
import { useLobbyDayAttendees } from '../../../hooks/useLobbyDay'
import { TargetsCoveragePanel } from './TargetsCoveragePanel'
import { RecruitWorkspace } from './RecruitWorkspace'
import type { AddedAttendeeToken, Chamber } from '../../../types/lobbyDay'

interface RecruitViewProps {
  eventId: string
  onAttendeesAdded?: (tokens: AddedAttendeeToken[]) => void
}

export function RecruitView({ eventId, onAttendeesAdded }: RecruitViewProps) {
  const [findConstituents, setFindConstituents] =
    useState<{ nonce: number; chamber: Chamber; districtValues: string[] } | undefined>(undefined)
  const { data: attendees } = useLobbyDayAttendees(eventId)

  return (
    <VStack align="stretch" gap={4}>
      <TargetsCoveragePanel
        eventId={eventId}
        onFindConstituents={({ chamber, districtValues }) =>
          setFindConstituents((prev) => ({ nonce: (prev?.nonce ?? 0) + 1, chamber, districtValues }))
        }
      />
      <RecruitWorkspace
        eventId={eventId}
        findConstituents={findConstituents}
        existingContactIds={(attendees ?? []).map((a) => a.contactId)}
        onAttendeesAdded={onAttendeesAdded}
      />
    </VStack>
  );
}
